import { Browser } from '@capacitor/browser';
import { IonButton, IonContent, IonPage, IonSpinner } from '@ionic/react';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import stoneageLogo from '../assets/images/StoneAgeTransparentBackground.png';
import globalStyles from '../global-styles/rootGlobalStyles';
import { HomeMessages } from '../intl/HomeMessages';

export interface TosComponentProps {
  isLoading: boolean;
  handleAccept: () => void;
}

const URL_EULA = 'https://www.stoneagetools.com/eula';
const URL_PRIVACY = 'https://www.stoneagetools.com/privacy-sentinel';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
  },
  headerImage: {
    height: '96px',
  },
  button: {
    width: '100%',
    [globalStyles.Device.Laptop]: {
      maxWidth: '25vw',
    },
  },
}));

export const TosComponent: React.FC<TosComponentProps> = ({ isLoading, handleAccept }) => {
  const styles = useStyles();

  return (
    <IonPage>
      <IonContent scrollY={false} className="ion-padding">
        <div className={styles.container}>
          <img src={stoneageLogo} className={styles.headerImage} alt="StoneAge logo" />
          <h4>
            <FormattedMessage {...HomeMessages.reviewTosHeader} />
          </h4>
          <IonButton
            expand="block"
            size="large"
            fill="outline"
            className={styles.button}
            onClick={() => {
              Browser.open({ url: URL_EULA, presentationStyle: 'popover', windowName: '_blank' });
            }}
            disabled={isLoading}
          >
            <FormattedMessage {...HomeMessages.reviewTosTermsButton} />
          </IonButton>
          <IonButton
            expand="block"
            size="large"
            fill="outline"
            className={styles.button}
            onClick={() => {
              Browser.open({ url: URL_PRIVACY, presentationStyle: 'popover', windowName: '_blank' });
            }}
            disabled={isLoading}
          >
            <FormattedMessage {...HomeMessages.reviewTosPrivacyButton} />
          </IonButton>
          <IonButton expand="block" size="large" className={styles.button} disabled={isLoading} onClick={handleAccept}>
            {isLoading ? <IonSpinner name="circles" /> : <FormattedMessage {...HomeMessages.reviewTosAgreeButton} />}
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};
